import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Survey {
  name: string;
  api_token: string;
}

export interface SurveyListInfor {
  errors: unknown;
  survey: Survey;
  isAuthenticated: boolean;
}

@Module
export default class SurveyModule
  extends VuexModule
  implements SurveyListInfor
{
  errors = {};
  survey = {} as Survey;
  surveyResultData = {};
  isAuthenticated = !!JwtService.getToken();

  get Surveys() {
    return this.surveyListData;
  }

  get getSurveyResult() {
    return this.surveyResultData;
  }

  @Mutation
  [Mutations.SURVEYS_LIST_DATA](Surveys) {
    this.surveyListData = Surveys;
  }

  @Mutation
  [Mutations.SURVEY_RESULT_DATA](surveyResult) {
    this.surveyResultData = surveyResult;
  }

  @Action
  [Actions.SURVEYS_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("survey", payload)
        .then((data) => {
          this.context.commit(Mutations.SURVEYS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.SURVEY_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("survey/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.SURVEYS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.SURVEY_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/survey", "upsert", id, payload)
        .then((data) => {
          this.context.commit(Mutations.SURVEYS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.SURVEY_RESULT](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post(`/survey/${payload.id}/result`)
        .then((data) => {
          this.context.commit(Mutations.SURVEY_RESULT_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.SURVEY_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/survey", payload, "delete", payload)
        .then((data) => {
          this.context.commit(Mutations.SURVEYS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
